/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

import LocalizedString from '~components/text/LocalizedString';

import normalizeOption from './normalizeOption';

const getSelectedOption = (value, options) => {
    const nOption = normalizeOption(value);
    let selectedOption = options.find((otherOption) => {
        const nOtherOption = normalizeOption(otherOption);
        return nOtherOption.value === nOption.value;
    });
    if (!selectedOption) {
        let label = nOption.label;
        if (label === null || label === undefined || label === '') {
            // There's no selection, and there isn't some explicit label for the selection - show a "SELECT" type of notice
            label = <LocalizedString localeKey="COMMON_UI.LABEL.DROPDOWN__NO_SELECTION" />;
        } else {
            // There's a selection, but it's no longer valid - show an "(INVALID)" prefix before the label
            label = <><LocalizedString localeKey="COMMON_UI.LABEL.DROPDOWN__INVALID_PREFIX" /> {label}</>;
        }
        selectedOption = {
            invalid: true,
            value: nOption.value,
            label,
        };
    } else {
        selectedOption = normalizeOption(selectedOption);
    }
    return selectedOption;
};

export default getSelectedOption;
